import { ExclamationCircleFilled, CheckCircleFilled, ClockCircleFilled } from '@ant-design/icons';

export const TYPE_ARR = new Map([
  [
    'red',
    <ExclamationCircleFilled
      key={1}
      style={{
        color: '#FF4C4C',
        fontSize: '16px',
      }}
    />,
  ],
  [
    'green',
    <CheckCircleFilled
      key={2}
      style={{
        color: '#17C574',
        fontSize: '16px',
      }}
    />,
  ],
  [
    'blue',
    <ClockCircleFilled
      key={3}
      style={{
        color: '#2D64FF',
        fontSize: '16px',
      }}
    />,
  ],
  ['gray', null],
]);
